import router from '@/router/index'
import request from '@/utils/apiRequest'

async function getPermissionList() {
  const res = await request({
    url: '/user/hiddenDangerRecordAuditLog/list',
    params: {
      hiddenDangerRecordId: this.hiddenDangerRecordId
    },
    method: 'post'
  })
}

const user = {
  state: {
    base: null,
    permissions: {},
    roles: [],
    roleIds: [],
    inited: false,
    userInfo: null
  },
  mutations: {
    CLEAR_USERINFO(state){
      state.base = null;
      state.roleIds =[];
      state.roles = [];
      state.permissions = {};
      state.menus =[];
      // state.routes = [];
    },
    SET_USERINFO(state, data) {
      state.base = data.base||{};
      state.roleIds = data.roleIds||[];
      state.roles = data.roles||[];
      state.permissions = data.permissions||[];
      state.menus = data.menus||[];
      state.inited = false;
      if (state.userInfo == null && data.userInfo != null) {
        state.userInfo = data.userInfo
      }
      this.commit('SET_PERMISSION')
    },
    SET_INITED(state, val) {
      state.inited = val;
    },
    SET_PERMISSION() {
    }
  },
  actions: {
    clearUserInfo(commit){
      commit("CLEAR_USERINFO");
    },
    setUserInfo({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_USERINFO", data);
        commit("SET_INITED", true);
        sessionStorage.setItem(
          "state",
          JSON.stringify({
            state: { app: rootState.app, user: rootState.user }
          })
        );
        resolve();
      });
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        sessionStorage.removeItem("access_token");
        sessionStorage.removeItem("refresh_token");
        sessionStorage.clear();
        resolve();
      });
    },
    generateNav({ commit }, nav) {
      commit("SET_NAV", nav);
    }
  }
};

export default user;
